var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container filmswiper"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-box",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "slide_item",
      attrs: {
        "src": item.img,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.jumpto(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "my-swiper-pre",
    attrs: {
      "slot": "button-prev"
    },
    on: {
      "click": _vm.handelPre
    },
    slot: "button-prev"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-swiper-next",
    attrs: {
      "slot": "button-next"
    },
    on: {
      "click": _vm.handeNext
    },
    slot: "button-next"
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])], 2)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404af75a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mySwiper.vue
// module id = null
// module chunks = 